import Tabs from './Tabs';
import TabPane from './TabPanelList/TabPane';
export { TabPane };
export default Tabs;
